import { mapParamsBySchema } from '../../../../util';
import { apiRequest } from '../../../../Services/Common/ApiRequest';
import Global from '../../../../Services/Common/Global';
import { M_WorkPermits_BASIC_Schema } from './M_WorkPermits_BASIC_Schema';
import useSearchMutaion from '../../../../Hooks/apis/useSearchMutaion';

/** 안전작업허가서 마스터 목록 조회 getTbmNewR6 */
export const useSearch1 = (successOptions) => {
  return useSearchMutaion(async (context) => {
    const payload = mapParamsBySchema(
      M_WorkPermits_BASIC_Schema.mapper.search1,
      context
    );
    return apiRequest('post', Global.urls.ToolBoxMeeting.getTbmNewR6, payload);
  }, successOptions);
};

/** 안전작업허가서 데일리 목록 조회 getTbmNewR7 */
export const useSearch2 = (successOptions) => {
  return useSearchMutaion(async (context) => {
    const payload = mapParamsBySchema(
      M_WorkPermits_BASIC_Schema.mapper.search2,
      context
    );
    return apiRequest('post', Global.urls.ToolBoxMeeting.getTbmNewR7, payload);
  }, successOptions);
};